module.exports = __webpack_public_path__ + "img/noProfile.a92af394.jpg";